import { render, staticRenderFns } from "./RewordStandard.vue?vue&type=template&id=38ed7fa5&scoped=true"
import script from "./RewordStandard.vue?vue&type=script&lang=js"
export * from "./RewordStandard.vue?vue&type=script&lang=js"
import style0 from "./RewordStandard.vue?vue&type=style&index=0&id=38ed7fa5&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ed7fa5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38ed7fa5')) {
      api.createRecord('38ed7fa5', component.options)
    } else {
      api.reload('38ed7fa5', component.options)
    }
    module.hot.accept("./RewordStandard.vue?vue&type=template&id=38ed7fa5&scoped=true", function () {
      api.rerender('38ed7fa5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/cps/views/treety/modules/components/RewordStandard.vue"
export default component.exports